<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-card-title
        ><i class="fas fa-times-circle" style="color: red;"></i
      ></v-card-title>
      <template v-if="!!message">
        <template v-if="Array.isArray(message)">
          <v-card-text class="error-dialog-message">
            <p v-for="(value, key) in message" :key="key">
              {{ value }}
            </p>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text style="white-space:pre-wrap;">{{ message }}</v-card-text>
        </template>
      </template>
      <template v-else>
        <v-card-text></v-card-text>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btn-primary" @click.native="close">
          確認
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    options: {
      width: 400
    }
  }),
  methods: {
    open(message, options) {
      this.dialog = true;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close() {
      this.resolve(true);
      this.dialog = false;
    }
  }
};
</script>
